import { ExternalTextLink } from "@/components/Links";
import { CMP_PATIENTS_TESTS_URL, CMP_PATIENTS_URL, getCmpUrl } from "@/core/urls";
import {
  PROGRESS_STATUS_INTERIM_RESULTS_RELEASED,
  PROGRESS_STATUS_PARTIAL_RESULTS_RELEASED,
  PROGRESS_STATUS_RESULTS_RELEASED,
  PROGRESS_STATUS_REVIEW_RESULTS
} from "@/tpo/shop/constants";

export default function getProgressStatusBadgeProps({
  derivedProgressStatus,
  organisationId,
  patientId
}) {
  if (derivedProgressStatus === PROGRESS_STATUS_REVIEW_RESULTS) {
    if (!organisationId) {
      return {};
    }

    return {
      as: ExternalTextLink,
      href: getCmpUrl(`${CMP_PATIENTS_URL}/new_results`, {
        organisationId
      }),
      underline: false,
      onClick: e => {
        e.stopPropagation();
      }
    };
  }

  if (
    [
      PROGRESS_STATUS_INTERIM_RESULTS_RELEASED,
      PROGRESS_STATUS_RESULTS_RELEASED,
      PROGRESS_STATUS_PARTIAL_RESULTS_RELEASED
    ].includes(derivedProgressStatus)
  ) {
    if (!patientId || !organisationId) {
      return {};
    }

    return {
      as: ExternalTextLink,
      href: getCmpUrl(CMP_PATIENTS_TESTS_URL, {
        patientId,
        organisationId
      }),
      underline: false,
      onClick: e => {
        e.stopPropagation();
      }
    };
  }

  return {};
}
